import { PALETTE } from '../../../../common/styles/palette';
export const styles = (theme: any) => {
    return {
        selectedContact: {
            backgroundColor: PALETTE.Contacts.List.SelectedContact.BackGroundColor,
            '&:hover': {
                backgroundColor: PALETTE.Contacts.List.SelectedContact.HoveredBackGroundColor
            },
        },
        contact: {
            '&:hover': {
                backgroundColor: PALETTE.Contacts.List.HoveredBackGroundColor
            },
        },
        messageIcon: {
            marginRight: 15,
        },
        tagsContainer: {
            paddingLeft: '10px'
        },
        roomsContainer: {
            paddingLeft: '10px'
        },
        userIcon: {
            minWidth: '0px',
            paddingRight: '10px'
        },
        userNameText: {
            paddingLeft: '20px'
        },
        roomContactEnabled: {
            width: "15px",
            height: "15px",
            borderRadius: "50%"
        }
    }
}